import React from "react";

// COPY LOCKED — do not paraphrase without client confirmation. See /app/memory/PRD.md.

const STEPS = [
    { n: "01", t: "Tell us about your project", b: "Share a few details about your property, what you're considering, your anticipated construction budget and when you hope to begin." },
    { n: "02", t: "We review feasibility", b: "We'll review the property and proposed works and contact you to discuss what you're hoping to achieve." },
    { n: "03", t: "We develop your design", b: "We develop the concept and layout through to a level of architectural detail typically prepared for a planning application." },
    { n: "04", t: "You decide what happens next", b: "If you'd like us to deliver the construction, we can take the project forward. If you decide to use another builder, there is no design fee to repay." },
];

export default function HowItWorks() {
    const scrollToForm = () => document.querySelector("#enquiry-form")?.scrollIntoView({ behavior: "smooth" });
    return (
        <section id="how-it-works" className="bg-charcoal text-offwhite py-12 md:py-16" data-testid="section-how-it-works">
            <div className="max-w-[1200px] mx-auto px-6 md:px-10">
                <p className="font-manrope font-semibold text-terracotta text-[12px] tracking-[0.22em] uppercase mb-4">
                    How It Works
                </p>
                <h2 className="font-manrope font-bold text-offwhite text-[34px] md:text-[44px] leading-[1.05] tracking-tight mb-14 md:mb-20 max-w-[720px]">
                    Four steps from enquiry to finished design
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-10">
                    {STEPS.map((s) => (
                        <div key={s.n} data-testid={`step-${s.n}`}>
                            <div className="font-manrope font-extrabold text-terracotta text-[56px] md:text-[64px] leading-none tracking-tight mb-4">
                                {s.n}
                            </div>
                            <h3 className="font-manrope font-bold text-offwhite text-[19px] md:text-[20px] mb-3 leading-tight">
                                {s.t}
                            </h3>
                            <p className="font-inter text-[15px] leading-relaxed text-offwhite/70">
                                {s.b}
                            </p>
                        </div>
                    ))}
                </div>
                <div className="mt-16 md:mt-20 flex justify-center">
                    <button
                        onClick={scrollToForm}
                        className="font-manrope font-bold text-[15px] md:text-[16px] px-7 py-3.5 rounded-md bg-terracotta text-offwhite hover:bg-terracotta-600 hover:-translate-y-0.5 transition-all"
                        data-testid="how-it-works-cta"
                    >
                        Get Your Free Design
                    </button>
                </div>
            </div>
        </section>
    );
}
